/*
 * VOLTAJE — <vj-unfold>: abre una escena (capas que se separan, hilo que se cose…) la primera vez
 * que entra en pantalla. Lo usan las secciones "Anatomía" y "Hecho a mano".
 *
 * El estado final es el de por defecto en el CSS: solo se "cierra" ([data-armed]) cuando se va a
 * animar de verdad. Así, en el editor de Shopify, con movimiento reducido, sin animaciones en los
 * ajustes del tema o si este script no llega a cargarse, la escena se ve completa y quieta.
 */
if (!customElements.get('vj-unfold')) {
  customElements.define(
    'vj-unfold',
    class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-animate')) return;
        if (window.Shopify && window.Shopify.designMode) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        // Se cierra al instante (sin transición) para no verla plegarse al cargar la página.
        this.dataset.instant = '';
        this.dataset.armed = '';
        void this.offsetHeight;
        delete this.dataset.instant;
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            // Un fotograma de margen para que el navegador pinte el estado cerrado antes de abrir.
            requestAnimationFrame(() => {
              this.dataset.open = '';
            });
          },
          { rootMargin: '0px 0px -20% 0px', threshold: 0.2 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
